const  API_PATH = "https://api.vancouver-live.fr/api";
// const API_PATH = "http://localhost/vancouverlive-api/api"

export default API_PATH;